export const WORKSPACE_RAIL_BOOTSTRAP_READY_EVENT = 'output:internal:workspace-rail-bootstrap-ready';

export function isWorkspaceRailBootstrapReady() {
  return Boolean(window.output?.workspaceRailBootstrapReady);
}

export function resetWorkspaceRailBootstrapReady() {
  if (window.output) delete window.output.workspaceRailBootstrapReady;
}

export function markWorkspaceRailBootstrapReady() {
  window.output = window.output || {};
  window.output.workspaceRailBootstrapReady = Date.now();
  window.dispatchEvent(new CustomEvent(WORKSPACE_RAIL_BOOTSTRAP_READY_EVENT));
}

export function workspaceRailSourcesReady({ bootstrapReady, workspacesReady, directMessagesReady, cachedRowCount = 0 }) {
  if (!workspacesReady || !directMessagesReady) return false;

  // A warm cache is useful immediately; a cold empty cache waits for the identity
  // snapshot so the UI does not flash an empty rail before the first network response.
  return bootstrapReady || cachedRowCount > 0;
}
